import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ContractTypeId {
  COLLABORATION = 2,
  LICENSE = 3,
  OTHER = 5,
  RESERVATION_PLUS = 6,
  MARKETING_PLUS = 7,
  GLOBAL_CONTRACT = 8,
  GLOBAL_SETUP_FORM = 9,
  GENERAL_CONTRACT = 10,
  PAYU = 11,
  POS = 12,
  WEB_PLUS = 13,
  PAY_TERMINAL = 14,
  PAY_ONLINE_GATEWAY = 15,
  PAY_AGREEMENT = 16,
  LEAD = 17,
  API = 18,
  GDPR_AGREEMENT = 19,
  SPA_CZ_AGREEMENT = 20,
  HOTELCZ_AGREEMENT = 22,
  P_PLUS = 23,
}

export class ContractType extends Codebook<ContractTypeId> {
  static readonly COLLABORATION = new ContractType(
    ContractTypeId.COLLABORATION,
    () => $t('Collaboration amendment'),
    true,
  )
  static readonly LICENSE = new ContractType(
    ContractTypeId.LICENSE,
    () => $t('PMS amendment'),
    true,
  )
  static readonly OTHER = new ContractType(ContractTypeId.OTHER, () => $t('Other'), true)
  static readonly RESERVATION_PLUS = new ContractType(
    ContractTypeId.RESERVATION_PLUS,
    () => $t('Reservation+ contract'),
    false,
  )
  static readonly MARKETING_PLUS = new ContractType(
    ContractTypeId.MARKETING_PLUS,
    () => $t('Marketing contract'),
    true,
  )
  static readonly GLOBAL_CONTRACT = new ContractType(
    ContractTypeId.GLOBAL_CONTRACT,
    () => $t('CHM amendment'),
    true,
  )
  static readonly GLOBAL_SETUP_FORM = new ContractType(
    ContractTypeId.GLOBAL_SETUP_FORM,
    () => $t('Global setup form'),
    false,
  )
  static readonly GENERAL_CONTRACT = new ContractType(
    ContractTypeId.GENERAL_CONTRACT,
    () => $t('General contract'),
    true,
  )
  static readonly PAYU = new ContractType(ContractTypeId.PAYU, () => $t('PayU'), false)
  static readonly POS = new ContractType(ContractTypeId.POS, () => $t('POS'), false)
  static readonly WEB_PLUS = new ContractType(
    ContractTypeId.WEB_PLUS,
    () => $t('WEB contract'),
    true,
  )
  static readonly PAY_TERMINAL = new ContractType(
    ContractTypeId.PAY_TERMINAL,
    () => $t('PAY - terminal'),
    true,
  )
  static readonly PAY_ONLINE_GATEWAY = new ContractType(
    ContractTypeId.PAY_ONLINE_GATEWAY,
    () => $t('PAY - online'),
    true,
  )
  static readonly PAY_AGREEMENT = new ContractType(
    ContractTypeId.PAY_AGREEMENT,
    () => $t('PAY - agreement'),
    true,
  )
  static readonly LEAD = new ContractType(ContractTypeId.LEAD, () => $t('Lead'), false)
  static readonly API = new ContractType(ContractTypeId.API, () => $t('API contract'), false)
  static readonly GDPR_AGREEMENT = new ContractType(
    ContractTypeId.GDPR_AGREEMENT,
    () => $t('Consent to the processing of personal data'),
    false,
  )
  static readonly SPA_CZ_AGREEMENT = new ContractType(
    ContractTypeId.SPA_CZ_AGREEMENT,
    () => $t('SPA.cz cooperation contract'),
    false,
  )
  static readonly HOTELCZ_AGREEMENT = new ContractType(
    ContractTypeId.HOTELCZ_AGREEMENT,
    () => $t('HOTEL.CZ contract'),
    false,
  )
  static readonly P_PLUS = new ContractType(ContractTypeId.P_PLUS, () => $t('P+ contract'), true)

  private constructor(
    id: ContractTypeId,
    public readonly name: () => string,
    public readonly isActive: boolean,
  ) {
    super(id)
  }
}
